import { useRuntimeConfig } from "#app";

interface CardData {
  name: string;
  number: string;
  cvc: string;
  expiry: string;
}

export const useStripe = () => {
  const config = useRuntimeConfig();

  const getStripeToken = async (cardData: CardData) => {
    try {
      const [month, year] = cardData.expiry.split("/");

      const formData = new URLSearchParams();

      // Card details
      formData.append("card[name]", cardData.name);
      formData.append("card[number]", cardData.number.replace(/\s/g, ""));
      formData.append("card[cvc]", cardData.cvc);
      formData.append("card[exp_month]", month);
      formData.append("card[exp_year]", year);

      // Stripe public key
      formData.append("key", config.public.STRIPE_PUBLIC_KEY);

      const response = await fetch("https://api.stripe.com/v1/tokens", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
        body: formData,
      });

      const data = await response.json();

      if (data.error) {
        throw new Error(data.error.message);
      }

      return data;
    } catch (error: any) {
      throw new Error(
        error.message || "Failed to process card. Please try again."
      );
    }
  };

  const getCardType = (token: any) => {
    const cardBrand = token.card.brand;
    // Stripe returns lowercase brand names, let's capitalize them
    return cardBrand.charAt(0).toUpperCase() + cardBrand.slice(1);
  };

  return {
    getStripeToken,
    getCardType,
  };
};
